import { VendorCustomerOperationTypeEnum } from "./../../../dtos/catalogs/vendorcustomer/VendorCustomerOperationTypeEnum";
import React from "react";
import { VendorCustomerDetail } from "../../../components/Pages/Catalogs/VendorCustomer/VendorCustomerDetail";
import { VendorCustomerService } from "../../../services/catalogs/VendorCustomerService";
import { ICreateVendorCustomerDto } from "../../../dtos/catalogs/vendorcustomer/ICreateVendorCustomerDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupVendorCustomer } from "../../../components/Shared/NewForms/NFLookupVendorCustomer";
import VendorCustomerList from "../../../components/Pages/Catalogs/VendorCustomer/VendorCustomerList";

export const VendorCustomer: IAppEntity = {
  entityType: "catalog",
  title: "VendorCustomer",
  pluralTitle: "VendorCustomers",
  apiUrl: "VendorCustomers",
  apiEnum: ReferenceTypes.CatalogVendorCustomer,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(VendorCustomerDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(VendorCustomerList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupVendorCustomer, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new VendorCustomerService("VendorCustomers"),
  getEmptyModel: () => {
    const model: ICreateVendorCustomerDto = {
      name: "",
      isCustomer: false,
      isEmailValidVendorCustomer: false,
      isVendor: true,
      legalForm: VendorCustomerOperationTypeEnum.IndividualEntity,
      isOther: false,
      vatTaxable: false,
      createdDate: new Date(),
      vendorCustomerLegalForm: 0,
    };
    return model;
  },
};
